import {useQueryClient} from '@tanstack/react-query';
import {
  PostFieldDefinition,
  DeleteFieldDefinition,
  SaveFieldDefinition,
} from '../../shared/api/definitions/fieldDefinition';
import {useApiMutation} from './api';
import {MetadataQueryKey} from '../../context/MetadataContext';

export const useCreateFieldDefinition = () => {
  const queryClient = useQueryClient();
  return useApiMutation(PostFieldDefinition, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
};

export const useDeleteFieldDefinition = () => {
  const queryClient = useQueryClient();
  return useApiMutation(DeleteFieldDefinition, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
};

export const useSaveFieldDefinition = () => {
  const queryClient = useQueryClient();
  return useApiMutation(SaveFieldDefinition, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [MetadataQueryKey],
      });
    },
  });
};
